if (!customElements.get('sentinel-header')) {
  customElements.define('sentinel-header', class extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.mobileMenu = this.querySelector('.sentinel-header__mobile-menu');
      this.desktopMedia = window.matchMedia('(min-width: 1100px)');

      const secondaryCart = this.querySelector('[data-secondary-cart]');
      const originalCart = document.getElementById('cart-icon-bubble');
      if (secondaryCart && originalCart) {
        secondaryCart.addEventListener('click', event => {
          const drawer = document.querySelector('cart-drawer');
          if (typeof drawer?.open === 'function') {
            event.preventDefault();
            drawer.open(secondaryCart);
          }
        }, options);
        const syncCartCount = () => {
          secondaryCart.querySelector('.cart-count-bubble')?.remove();
          const count = originalCart.querySelector('.cart-count-bubble');
          if (count) secondaryCart.append(count.cloneNode(true));
        };
        this.cartObserver = new MutationObserver(syncCartCount);
        this.cartObserver.observe(originalCart, { childList: true, subtree: true, characterData: true });
        syncCartCount();
      }

      this.closeDetails = (details, restoreFocus = false) => {
        details.open = false;
        details.querySelectorAll('details[open]').forEach(child => { child.open = false; });
        if (restoreFocus) details.querySelector('summary').focus();
      };

      this.querySelectorAll('details').forEach(details => {
        const summary = details.querySelector(':scope > summary');
        summary.setAttribute('aria-expanded', String(details.open));
        details.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(details.open));
          if (!details.open) return;
          const list = details.parentElement.parentElement;
          list.querySelectorAll(':scope > li > details[open]').forEach(sibling => {
            if (sibling !== details) this.closeDetails(sibling);
          });
        }, options);
      });

      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const details = event.target.closest('details[open]');
        if (details) {
          event.preventDefault();
          event.stopPropagation();
          this.closeDetails(details, true);
        }
      }, options);

      document.addEventListener('click', event => {
        this.querySelectorAll('details[open]').forEach(details => {
          if (!details.contains(event.target)) this.closeDetails(details);
        });
      }, options);

      this.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (!this.isConnected) return;
          this.querySelectorAll('details[open]').forEach(details => {
            if (!details.contains(document.activeElement)) this.closeDetails(details);
          });
        });
      }, options);

      this.desktopMedia.addEventListener('change', () => {
        const focusedDetails = document.activeElement.closest('details[open]');
        this.querySelectorAll('details[open]').forEach(details => this.closeDetails(details));
        if (focusedDetails && this.contains(focusedDetails)) this.querySelector('.sentinel-header__logo').focus();
      }, options);
    }

    disconnectedCallback() {
      this.abortController.abort();
      this.cartObserver?.disconnect();
    }
  });
}
